import { Component, OnInit } from '@angular/core';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2';
import {JardinModel, ResponseJardinModel} from 'src/app/model/Jardin.model';

@Component({
  selector: 'app-mantenedor-pei',
  templateUrl: './mantenedor-pei.component.html',
  styleUrls: ['./mantenedor-pei.component.css']
})
export class MantenedorPEIComponent implements OnInit {

  codigoJardinRBD:number;
  busquedaOK:boolean;
  dataJardin = new JardinModel();
  respuesta : string;
  

  constructor(private api: apiService,) { }

  ngOnInit(): void {
    this.busquedaOK = false;
  }


  obtenerjardin(){
    
    this.api.API_POST_obtenerJardinPorRBD(this.codigoJardinRBD).subscribe((response:ResponseJardinModel) => {
      this.dataJardin = response.payload;
      this.busquedaOK = true;
    },
    (err) => { 
      console.log(err)
      this.busquedaOK = false;
      Swal.fire({
        title: 'Error al Cargar Jardín',
        text: 'Validar que el Código del jardín sea correcto.',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    });
  }

  activar(){

    this.api.API_POST_activarJardin(this.dataJardin.id).subscribe((response:any) => {
      this.respuesta = response.payload;
      if(this.respuesta ==='OK'){
        
          Swal.fire({
            title: 'Activacion correcta',
            text: "Plan Educativo Activado para modificaciones.",
            icon: "success",
            confirmButtonText: 'OK'
          });

               this.obtenerjardin();
      }

      //this.busquedaOK = true;
    },
    (err) => { 
      console.log(err)
      this.busquedaOK = false;
      Swal.fire({
        title: 'Error al Cargar Jardín',
        text: 'Validar que el Código del jardín sea correcto.',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    });

  }

}
